module.exports = __webpack_public_path__ + "static/media/Evelynn_0.173b5bbc.jpg";